// extracted by mini-css-extract-plugin
export default {"selections":"Selections_selections__duCHg"};